import axios from 'axios';
import { Basename_url, RCP_API_URL } from 'constant/app.config';

const saveErrorLog = (error) => {
  try {
    const existingLogs = JSON.parse(localStorage.getItem('errorLogs')) || [];

    const newLog = {
      message: error.message,
      status: error?.response?.status,
      url: error?.config?.url,
      time: new Date().toISOString(),
    };

    existingLogs.push(newLog);

    localStorage.setItem('errorLogs', JSON.stringify(existingLogs));
  } catch (e) {
    console.error('Failed to save log', e);
  }
};

const forceLogout = (error) => {
  // ✅ only logout on 401 (not 404 or other errors)
  if (error?.response?.status === 401) {
    // preserve logs
    const logsBackup = localStorage.getItem('errorLogs');

    // clear everything
    localStorage.clear();
    sessionStorage.clear();

    // restore logs AFTER clear
    if (logsBackup) {
      localStorage.setItem('errorLogs', logsBackup);
      localStorage.setItem(
        'isexpired',
        'Your session has expired. Please log in again to continue.'
      );
    }

    window.location.replace(Basename_url);
  }
};

export const getMoxoToken = async (useremail) => {
  try {
    let resp;

    resp = await axios.post(
      `${RCP_API_URL}` + `v1/core/oauth/token`,
      {
        org_id: 'Pd7iYEBgFzz1IzINAWois2I',
        unique_id: useremail,
        client_id: 'NDY2NGY2OWR',
        client_secret: 'Y2Y1OTE4NDR',
      },
      {
        headers: {},
      }
    );

    console.log('MOXO Token checking', resp.data.access_token);

    return resp.data;
  } catch (error) {
    console.error('Error fetching Moxo Binder:', error);

    // redirect globally (works from anywhere)
    saveErrorLog(error); // ✅ save first

    forceLogout(error);

    throw error; // Rethrow the error after logging it
  }
};

export const getMoxoBinder = async () => {
  try {
    const token = localStorage.getItem('moxoDetail');
    const bearerToken = 'Bearer ' + JSON.parse(token);
    const resp = await axios.get(
      `${RCP_API_URL}` + `v1/me/binder`,

      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      }
    );

    return resp.data;
  } catch (error) {
    console.error('Error fetching Moxo Binder:', error);

    // redirect globally (works from anywhere)
    saveErrorLog(error); // ✅ save first

    forceLogout(error);

    throw error; // Rethrow the error after logging it
  }
};

export const getMoxoAcions = async () => {
  try {
    let token = localStorage.getItem('moxoDetail');
    const bearerToken = 'Bearer ' + JSON.parse(token);
    const resp = await axios.get(
      `${RCP_API_URL}` + `v1/me/actions`,

      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      }
    );
    return resp.data;
  } catch (error) {
    console.error('Error fetching Moxo Binder:', error);

    // redirect globally (works from anywhere)
    saveErrorLog(error); // ✅ save first

    forceLogout(error);

    throw error; // Rethrow the error after logging it
  }
};

export const getMoxoBinderdetails = async (binderid) => {
  try {
    const token = JSON.parse(localStorage.getItem('moxoDetail'));
    const bearerToken = 'Bearer ' + token;

    const resp = await axios.get(
      `${RCP_API_URL}` + `v1/sdk/binder/${binderid}/users`,

      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      }
    );

    if (resp?.data?.code == 'YRY_OK') {
      return resp?.data?.data;
    }
  } catch (error) {
    console.error('Error fetching Moxo Binder:', error);

    // redirect globally (works from anywhere)
    saveErrorLog(error); // ✅ save first

    forceLogout(error);

    throw error; // Rethrow the error after logging it
  }
};

export const getMoxoActionsByFilter = async (filter) => {
  try {
    const token = localStorage.getItem('moxoDetail');
    const bearerToken = 'Bearer ' + JSON.parse(token);

    const resp = await axios.get(
      `${RCP_API_URL}v1/me/actions?filter=${filter}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      }
    );

    if (resp?.data?.code == 'YRY_OK') {
      return resp?.data;
    }
  } catch (error) {
    console.error(`Error fetching Moxo Actions (${filter}):`, error);

    // save log first
    saveErrorLog(error);

    // logout only if 401
    forceLogout(error);

    throw error;
  }
};

export const getMoxoActionsByFilterForOther = async (
  filter,
  otherusertoken
) => {
  try {
    const bearerToken = 'Bearer ' + otherusertoken;

    const resp = await axios.get(
      `${RCP_API_URL}v1/me/actions?filter=${filter}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      }
    );

    if (resp?.data?.code == 'YRY_OK') {
      return resp?.data;
    }
  } catch (error) {
    console.error(`Error fetching Moxo Actions (${filter}):`, error);

    // save log first
    saveErrorLog(error);

    // logout only if 401
    forceLogout(error);

    throw error;
  }
};

export const updateMoxoNotificationAction = async (id, action, value) => {
  try {
    const token = localStorage.getItem('moxoDetail');
    const bearerToken = 'Bearer ' + JSON.parse(token);

    const resp = await axios.post(
      `${RCP_API_URL}v1/transobjects/${id}/notification`,
      {
        action: action,
        value: value,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      }
    );

    return resp.data;
  } catch (error) {
    console.error(`Error updating notification (${action}):`, error);

    saveErrorLog(error);
    forceLogout(error);

    throw error;
  }
};

export const markMoxoAsRead = async (objectId) => {
  try {
    const token = localStorage.getItem('moxoDetail');
    const bearerToken = 'Bearer ' + JSON.parse(token);

    const resp = await axios.post(
      `${RCP_API_URL}v1/markAsRead`,
      {
        object_id: objectId,
        object_type: 'TRANSOBJECT',
        is_read: true,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      }
    );

    return resp.data;
  } catch (error) {
    console.error('Error marking as read:', error);

    saveErrorLog(error); // save error
    forceLogout(error); // logout only if 401

    throw error;
  }
};

export const markMoxoAllAsRead = async () => {
  try {
    const token = localStorage.getItem('moxoDetail');
    const bearerToken = 'Bearer ' + JSON.parse(token);

    const resp = await axios.post(
      `${RCP_API_URL}v1/markAsRead`,
      {
        is_fully_read: true,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      }
    );

    return resp.data;
  } catch (error) {
    console.error('Error marking as read:', error);

    saveErrorLog(error); // save error
    forceLogout(error); // logout only if 401

    throw error;
  }
};

export const getbinderswithtags = async (url) => {
  try {
    const token = localStorage.getItem('moxoDetail');
    const bearerToken = 'Bearer ' + JSON.parse(token);

    const resp = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });
    return resp?.data;
  } catch (error) {
    console.error('Error fetching binders with tags:', error);

    saveErrorLog(error); // save error
    forceLogout(error); // logout only if 401

    throw error;
  }
};

export const activestatus = async (status, moxotoken) => {
  try {
    const token = moxotoken || JSON.parse(localStorage.getItem('moxoDetail'));

    const bearerToken = `Bearer ${token}`;

    const payload = {
      is_online: Boolean(status),
    };

    console.log('Sending payload:', payload);

    const resp = await axios.put(`${RCP_API_URL}v1/me/presence`, payload, {
      headers: {
        Authorization: bearerToken,
        'Content-Type': 'application/json',
      },
    });

    console.log('Presence response:', resp.data);

    return resp?.data;
  } catch (error) {
    console.error('Presence API Error:', error?.response?.data || error);

    saveErrorLog(error);
    forceLogout(error);

    throw error;
  }
};
